// Writing to `state` IS the mutation contract, so the rule cannot be satisfied here — the repo
// disables it globally in .eslintrc.js, and only the pre-commit strict pass for newly ADDED files
// turns it back on. Every sibling mutations module does the same thing and differs only in age.
/* eslint-disable no-param-reassign */
const setEditSelectedSlideIsMine = (state, payload) => {
  state.editSelectedSlideIsMine = payload
}

// AHA-47221: tick / untick one slide. A whole new array rather than a splice in place, so
// components reading the list re-render on Vue 2's array reactivity rules without needing
// Vue.set gymnastics.
const togglePptSelectedSlideId = (state, slideId) => {
  state.selectedSlideIds = state.selectedSlideIds.includes(slideId)
    ? state.selectedSlideIds.filter((id) => id !== slideId)
    : [...state.selectedSlideIds, slideId]
}

const setPptSelectedSlideIds = (state, slideIds) => {
  state.selectedSlideIds = slideIds
}

// AHA-47221: point the selection at the presentation now open in the editor, emptying it when
// that is a different presentation from the one the ids were ticked in.
//
// Guarded on equality rather than clearing on every call, because the caller is a watcher that
// also fires when the editor is remounted on the SAME presentation — a task-pane reload, an
// in-pane push onto another of the editor's routes — and a selection the user is still building
// has to survive that. The guard is what makes this safe to commit unconditionally.
const setPptSelectionPresentationId = (state, presentationId) => {
  if (state.selectedSlideIdsPresentationId === presentationId) return
  state.selectedSlideIdsPresentationId = presentationId
  state.selectedSlideIds = []
}

export default {
  setEditSelectedSlideIsMine,
  togglePptSelectedSlideId,
  setPptSelectedSlideIds,
  setPptSelectionPresentationId,
}
